import { render } from 'react-dom';
import browserCheck from '@ublend-npm/browser-check';
import App from './app';

(async () => {
  if (browserCheck.isAllowedBrowser()) {
    const app = await App();
    render(app, document.getElementById('app'));
  } else {
    render(browserCheck.AutoWarning(), document.getElementById('app'));
  }
})();
